import { Trans } from 'next-i18next'
import useConfig from 'modules/config/state/use-config'
import FlowTwoColumnStepLayout from '../../two-column-step-layout/two-column-step-layout'

export const MSFMessage = () => {
  const config = useConfig()
  const hasMSFSmsCopy = config.msfSmsCopy

  return (
    <>
      {hasMSFSmsCopy ? (
        <>
          <FlowTwoColumnStepLayout.FooterText>
            <Trans i18nKey="DonorInformation.MsfSmsCopy.message">
              By making a gift to MSF USA, you’ll receive an email confirming your donation, along
              with regular updates on our work in the field through emails and SMS messages (if
              mobile number is provided). You can update your preferences or unsubscribe at any
              time.
            </Trans>
          </FlowTwoColumnStepLayout.FooterText>
        </>
      ) : null}
    </>
  )
}
